import type { ExportDownloadOptions } from "@/domain/export";

/**
 * Helpers for building the `/<entity>/export*` URLs.
 *
 * Filter query params are passed in already-serialized as URLSearchParams so
 * each repository keeps full control over how its filters serialize.
 */

export function buildExportPreviewUrl(basePath: string, filters: URLSearchParams): string {
  const qs = filters.toString();
  return qs ? `${basePath}/export/preview?${qs}` : `${basePath}/export/preview`;
}

export function buildExportDownloadUrl(
  basePath: string,
  filters: URLSearchParams,
  options: ExportDownloadOptions,
): string {
  const query = new URLSearchParams(filters);
  query.set("format", options.format);
  if (options.columns.length > 0) {
    query.set("columns", options.columns.join(","));
  }
  if (options.sort_by) query.set("sort_by", options.sort_by);
  if (options.sort_direction) query.set("sort_direction", options.sort_direction);
  return `${basePath}/export?${query.toString()}`;
}
